import { ArrowLeft } from 'lucide-react';
import { NavLink, useSearchParams } from 'react-router-dom';
import { Button } from '../../../../components/ui/button';

// interface PostHeaderProps {
//   onEdit: () => void;
// }

const PostHeader = () => {
  const [searchParams] = useSearchParams();
  const platform = searchParams.get('name');
  const platformDisplayName = platform === 'linkedIn' ? 'LinkedIn' : 'X';

  return (
    <>
      {/* Desktop Header - Hidden on mobile */}
      <header className="hidden lg:flex items-center justify-between px-4 h-14 border-b text-text-primary">
        {/* Left section with back button and title */}
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            className="rounded-full"
            asChild
          >
            <NavLink to={'/social-media/get-started'}>
              <ArrowLeft className="h-4 w-4" />
            </NavLink>
          </Button>

          <div className="flex items-center gap-2">
            <span>Social /</span>
            <span className="font-medium">{platformDisplayName}</span>
          </div>
        </div>
      </header>

      {/* Mobile Header - Hidden on desktop */}
      <header className="lg:hidden flex items-center px-4 h-14 border-b text-text-primary">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            className="rounded-full -ml-3"
            asChild
          >
            <NavLink to={'/social-media/get-started'}>
              <ArrowLeft className="h-5 w-5" />
            </NavLink>
          </Button>

          <div className="flex items-center gap-2">
            <span>Social /</span>
            <span className="font-medium">{platformDisplayName}</span>
          </div>
        </div>
      </header>
    </>
  );
};

export default PostHeader;
